<template>
  <div class="col">
    <transition name="fade">
      <div v-if="!hot_slot.free" class="col-inner p-3 bg-white rounded">
        <div class="d-md-flex gap-3">
          <div class="col-md-4">
            <a :href="`/auctions/${this.auction_id}/lots/${hot_slot.lot.id}`">
              <img v-if="hot_slot.lot.images !== undefined"
                   :src="hot_slot.lot.images.length > 0 ? `/storage/${hot_slot.lot.images[0].path}` : '/images/cars/no_image.jpg'"
                   class="img-fluid card-img"
                   alt="car"
              >
            </a>
          </div>
          <div class="col">
            <h5 class="black-small-heading">
              {{ hot_slot.lot.car.name }}
            </h5>
            <div class="d-flex justify-content-between gap-2" role="group" aria-label="Basic example">
              <a
                role="button"
                class="extra-rounded text-center btn-lg btn-primary dark-button"
                @click="newRate(hot_slot.lot.id, hot_slot.lot.rate + 500)"
                :ref="'btnHotLot500' + hot_slot.lot.id"
              >
                {{ trans('rates.add500') }}
              </a>
              <a
                role="button"
                class="extra-rounded text-center btn-lg btn-primary dark-button"
                @click="newRate(hot_slot.lot.id, hot_slot.lot.rate + 1000)"
                :ref="'btnHotLot1000' + hot_slot.lot.id"
              >
                {{ trans('rates.add1000') }}
              </a>
              <a
                role="button"
                class="extra-rounded text-center btn-lg btn-primary dark-button"
                @click="newRate(hot_slot.lot.id, hot_slot.lot.rate + 2000)"
                :ref="'btnHotLot2000' + hot_slot.lot.id"
              >
                {{ trans('rates.add2000') }}
              </a>

            </div>
            <div v-if="hot_slot.lot.rate !== undefined  && auction_type === 'open'"
                 class="row mx-0 light-bg mt-2 extra-rounded justify-content-between"
            >
              <div class="col-6 px-0">
                <span class="font-s14 px-2 py-1 d-block text-start fw-bold-600">Høyeste bud</span>
              </div>
              <div class="col-6 px-0">
                  <span :key="hot_slot.lot.rate" class="font-s14 px-2 py-1 d-block text-end fw-bold-600">
                        {{ new Intl.NumberFormat('ru-RU').format(hot_slot.lot.rate) }}
                    <br/>
                    <strong v-if="hot_slot.lot.show_message_rate && hot_slot.lot.me_rate" class="text-success">
                      (mitt bud)
                    </strong>
                  </span>
              </div>
              <div v-if="hot_slot.lot.show_message_rate && !hot_slot.lot.me_rate" class="col-12 px-0 ">
                <span class="font-s14 px-2 pb-2 d-block text-end fw-bold-600">
                  <strong class="text-danger">(du har blitt overbudt!)</strong>
                </span>
              </div>
            </div>
            <div class="d-flex light-bg mt-2 extra-rounded justify-content-between">
              <div class="col-md-6">
                <span class="font-s14 px-2 py-1 d-block text-start fw-bold-600">Ditt siste bud</span>
              </div>
              <div class="col-md-6">
                <span class="font-s14 px-2 py-1 d-block text-end fw-bold-600">
                  {{
                    hot_slot.lot.rates !== undefined && hot_slot.lot.rates[0] !== undefined
                      ? new Intl.NumberFormat('ru-RU').format(hot_slot.lot.rates[0].rate)
                      : '0'
                  }}
                </span>
              </div>
            </div>
            <div
              class="d-flex light-bg extra-rounded my-2"
            >
              <div class="col-8">
                <span class="font-s14 px-2 py-2 d-block text-start fw-bold-600">Ditt autobud</span>
              </div>
              <div class="col-4">
                <span class="font-s14 px-2 py-2 d-block text-end fw-bold-600">
                     {{
                    (hot_slot.lot.auto_rates !== undefined && hot_slot.lot.auto_rates[0] !== undefined) ?
                      new Intl.NumberFormat('ru-RU').format(hot_slot.lot.auto_rates[0].rate) : '0'
                  }}
                </span>
              </div>
            </div>
            <div
              class="d-flex light-bg extra-rounded my-2"
              v-if="hot_slot.lot.show_min_price"
            >
              <div class="col-8">
                <span class="font-s14 px-2 py-2 d-block text-start fw-bold-600">Minstepris</span>
              </div>
              <div class="col-4">
                <span class="font-s14 px-2 py-2 d-block text-end fw-bold-600">
                      {{ new Intl.NumberFormat('ru-RU').format(hot_slot.lot.car.reserve_price) }}
                </span>
              </div>
            </div>
            <div class="d-block light-bg mt-2 extra-rounded">
              <div class="col">
                <timer-component
                  :time="time"
                  :time_end="hot_slot.lot.time_end"
                  :time_destroy="0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TimerComponent from "../TimerComponent";

export default {
  components: {TimerComponent},
  mounted() {
  },
  props: ['hot_slot', 'time', 'auction_id', 'auction_type'],
  data() {
    return {
      error: undefined
    }
  },
  methods: {
    newRate(lot_id, amount) {
      axios({
        url: `/auctions/${this.auction_id}/lots/ajax/${lot_id}`,
        method: 'PUT',
        data: {amount: amount}
      }).then(resp => {
      }).catch(err => {
        this.error = resp.response.data.message
      })
      this.$refs['btnHotLot500' + lot_id].blur()
      this.$refs['btnHotLot1000' + lot_id].blur()
      this.$refs['btnHotLot2000' + lot_id].blur()

    },
  }
}
</script>

<style>

</style>
